<template>
  <div class="container-fluid h-100 bg">
    <div class="row h-100 align-items-center justify-content-end m-0">
      
      <div class="col-12 col-md-5 col-lg-4 px-4 px-md-5">
        
        <div class="card-login-glass">
          <div class="card-body p-4 p-md-5">
            
            <div class="text-center mb-4">
              <img src="/img/logo.png" alt="Logo" class="w-50 login-logo" style="margin-bottom: -15px !important;"/>
              <h2 class="portal-title m-0 p-0">PORTAL</h2>
              <p class="signin-subtitle text-uppercase m-0">Sign In</p>
            </div>
            
            <div class="form-group mb-3">
              <label for="email" class="text-label mb-2">{{dicts.label_username[dicts.lang]}}</label>
              <input type="email" class="form-control" name="email" v-model="username" id="email" v-on:keyup.enter="loginNow" required autofocus placeholder="username">
            </div>
            
            <div class="form-group mb-4">
              <label for="password" class="text-label mb-2">{{dicts.label_password[dicts.lang]}}</label>
              <div class="password-wrapper">
                <input id="password" :type="[passVisible?'text':'password']" class="form-control" v-model="password" name="password" v-on:keyup.enter="loginNow" required placeholder="password">
                <a href="#" class="password-toggle" v-on:click.prevent="passVisible=!passVisible">
                  <i class="fa" :class="[passVisible ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i>
                </a>
              </div>
            </div>
            
            <div class="w-100 align-items-center justify-content-start" v-if="error">
              <div class="alert alert-danger" role="alert">
                Please double check your login details.
              </div>
            </div>
            
            <div class="text-center mt-4">
              <button type="submit" class="btn btn-login w-100" v-on:click="loginNow">
                <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                {{dicts.label_login_button[dicts.lang]}}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '../eventbus'
  import * as axios from 'axios';
  
  export default {
    components: {},
    data () {
      return {
        username:'',
        password:'',
        loading:false,
        error:false,
        passVisible:false,
        idleTimer: null,
        timeoutInMiliseconds: 15 * 60 * 1000, // Konfigurasi Auto-Logout: 15 Menit Tanpa Aktifitas
        dicts:{
          lang:'id',
          label_username:{
            id:"Username",
            en:"Username"
          },
          label_password:{
            id:"Password",
            en:"Password"
          },
          label_login_button:{
            id:"Log in",
            en:"Log in"
          }
        }
      }
    },
    methods:{
      loginNow(){
        if(this.username!='' && this.password!=''){
          this.loading=true;
          this.error=false;
          axios.post(this.$baseUrl+'/oauth/token',{
           username:this.username,
           password:this.password,
           grant_type:'password',
           client_id:'9371909b-625c-43a1-9016-43b0170887c9',
           client_secret:'TVhNQNB8Unmb3teKS8PKWFsEcQ4qGfQrqdu6B84W'
          }).then((result)=>{
            if(result.status==200){
              localStorage.setItem('accessToken',result.data.access_token);
              localStorage.setItem('refreshToken',result.data.refresh_token);
              this.whoami((whoamiResult)=>{
                console.log(whoamiResult)
                // Jalankan Idle Timer pelacak setelah berhasil login
                this.startIdleTimer();
                this.$router.push('/admin/home')
              })
            }else{
              this.error=true;
            }
            this.loading=false;
          }).catch((err)=>{
            if(err.response && err.response.status==401){
              this.clearSession();
              this.$router.push('/login')
            }
            this.loading=false;
            this.error=true;
            console.log(err)
          })
        }
      },
      whoami(callback){
        axios.get(this.$baseUrl+'/api/whoami',{
          'headers': {'Authorization':'Bearer '+localStorage.getItem('accessToken')}
        }).then((result)=>{
          if(result.status==200){
            localStorage.setItem('currentUser',result.data.user.name);
            localStorage.setItem('role',result.data.user.role);
            callback(true)
          }else{
            callback(false)
          }
        }).catch((err)=>{
          if(err.response && err.response.status==401){
            this.clearSession();
            this.$router.push('/login')
          }
          callback(false)
        })
      },
      // LOGIKA TIMEOUT / DETEKSI AKTIFITAS
      startIdleTimer() {
        window.addEventListener("mousemove", this.resetIdleTimer);
        window.addEventListener("click", this.resetIdleTimer);
        window.addEventListener("keydown", this.resetIdleTimer);
        window.addEventListener("scroll", this.resetIdleTimer);
        this.resetIdleTimer();
      },
      resetIdleTimer() {
        clearTimeout(this.idleTimer);
        this.idleTimer = setTimeout(this.forceLogout, this.timeoutInMiliseconds);
      },
      forceLogout() {
        this.clearSession();
        this.$router.push('/login');
        alert("Sesi Anda telah berakhir karena tidak ada aktivitas.");
      },
      clearSession() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('role');
      },
      destroyIdleTimer() {
        clearTimeout(this.idleTimer);
        window.removeEventListener("mousemove", this.resetIdleTimer);
        window.removeEventListener("click", this.resetIdleTimer);
        window.removeEventListener("keydown", this.resetIdleTimer);
        window.removeEventListener("scroll", this.resetIdleTimer);
      }
    },
    created(){
      if(localStorage.getItem('accessToken')){
        this.startIdleTimer();
        this.$router.push('/admin/home')
      }
      EventBus.$on('lang',()=>{
        this.dicts.lang = localStorage.getItem('lang');
      })
    },
    beforeDestroy() {
      this.destroyIdleTimer();
    }
  }
</script>

<style>
/* STYLE GLOBAL */
.app {
  height: 100vh;
}

/* CONTAINER UTAMA BACKGROUND TERANG & JERNIH */
.bg {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  z-index: 1;
  perspective: 1200px; 
  box-shadow: inset 0 0 100px rgba(255, 255, 255, 0.2);
}

/* RENDERING BACKGROUND JAUH DI DALAM (CRISP) */
.bg::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  
  background: 
    linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03)), 
    url('/img/background.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  
  filter: none; 
  transform: translateZ(-60px) scale(1.08); 
  
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  will-change: transform;
  z-index: -1;
}

/* KARTU KACA PREMIUM ULTRA TRANSPARAN DAN TIMBUL */
.card-login-glass {
  background: rgba(255, 255, 255, 0.02); 
  border-radius: 28px; 
  border: 1px solid rgba(255, 255, 255, 0.15); 
  
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  
  box-shadow: 
    0 4px 6px -1px rgba(0, 0, 0, 0.03),
    0 20px 50px -4px rgba(15, 23, 42, 0.15),
    0 40px 100px -10px rgba(0, 0, 0, 0.22) !important;
    
  transform: translateZ(20px);
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Efek interaktif ketika kursor menyentuh kartu (Tetap ultra transparan) */
.card-login-glass:hover {
  transform: translateZ(35px) translateY(-6px);
  box-shadow: 
    0 30px 60px -5px rgba(15, 23, 42, 0.22),
    0 50px 120px -10px rgba(0, 0, 0, 0.32) !important;
}

/* Desain Teks Label */
.text-label {
  color: #ffffff; 
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
}

/* Desain Kolom Input Bergaya Ultra Transparan */
.card-login-glass .form-control {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 14px;
  color: #0f172a;
  height: 48px;
  font-size: 0.95rem;
  padding: 10px 18px;
  transition: all 0.25s ease;
}

.card-login-glass .form-control:focus {
  background: rgba(255, 255, 255, 0.95);
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18);
}

/* Pembungkus posisi password dan icon mata agar presisi */
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  font-size: 1.1rem;
  transition: color 0.2s;
  z-index: 10;
}

.password-toggle:hover {
  color: #0f172a;
}
</style>

<style scoped>
/* STYLE SCOPED - KHUSUS KOMPONEN & TEXT DESIGN */
.login-logo {
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.08)) 
          drop-shadow(0 15px 25px rgba(0, 0, 0, 0.15));
}

.portal-title {
  color: #861717;
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: 4px;
  text-shadow: 0 2px 4px rgba(255, 255, 255, 0.5);
  margin-top: -50px !important; 
  margin-bottom: 0;
}

.signin-subtitle {
  color: #c7d1e0;
  font-size: 1.3rem; 
  font-weight: 700;  
  letter-spacing: 2px;
  margin: 0;        
  margin-top: 10px !important; 
}

.btn-login {
  padding: 14px 24px !important;
  border-radius: 14px;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #ffffff;
  border: none;
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.25) !important;
  transition: all 0.25s ease;
}

.btn-login:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(37, 99, 235, 0.35) !important;
  color: #ffffff;
}

.btn-login:active {
  transform: translateY(0);
}
.login-logo {
  /* 1. MENCERAHKAN GAMBAR ASLI */
  filter: brightness(1.15) contrast(1.05);
  
  /* 2. EFEK GABUNGAN: TERANG NYALAA + TIMBUL 3D 
     - Penulisan filter drop-shadow harus digabung dalam satu baris agar semuanya aktif bersamaan! */
  filter: 
    /* Lapisan 1: Pendaran biru terang di dekat logo agar menyala cerah */
    drop-shadow(0 2px 8px rgba(59, 130, 246, 0.45)) 
    /* Lapisan 2: Sebaran cahaya biru yang lebih luas */
    drop-shadow(0 10px 20px rgba(59, 130, 246, 0.25)) 
    /* Lapisan 3: Bayangan gelap halus berjarak dalam (Offset-Y 18px) untuk memberikan efek TIMBUL melayang */
    drop-shadow(0 18px 25px rgba(15, 23, 42, 0.35));

  /* 3. EFEK PERSPEKTIF 3D: Didorong sedikit ke depan secara dimensi */
  transform: translateZ(40px); 
  
  /* Menjaga tepian logo tetap tajam kristal tidak pecah */
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), filter 0.3s ease;
}

/* Efek interaktif: Saat kursor mendekati area login, logo akan terdorong makin timbul keluar */
.card-login-glass:hover .login-logo {
  transform: translateZ(60px) translateY(-4px) scale(1.03);
  filter: 
    brightness(1.2)
    drop-shadow(0 4px 12px rgba(59, 130, 246, 0.55))
    drop-shadow(0 15px 30px rgba(59, 130, 246, 0.35))
    drop-shadow(0 25px 35px rgba(15, 23, 42, 0.45));
}
</style>